// src/components/Header.js
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faBars,
  faTimes,
} from "@fortawesome/free-solid-svg-icons"; // ✅ added icons
import { Link, useNavigate } from "react-router-dom";
import DefaultImage from "../assets/img/profile.png";

const Header = ({ imageUrl }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // ✅ Track sidebar state
  const navigate = useNavigate();

  useEffect(() => {
    const userDataString = localStorage.getItem("user");
    if (userDataString) {
      try {
        const parsedUserData = JSON.parse(userDataString);
        setUserData(parsedUserData);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  // ✅ Watch for sidebar toggle via body class
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const isOpen = document.body.classList.contains("page-sidebar-toggled");
      setIsSidebarOpen(isOpen);
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setDropdownOpen((prev) => !prev);
  };

  const handleDropdownClose = () => setDropdownOpen(false);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.removeItem("crm_email_auth");
    sessionStorage.removeItem("subscriberFilterParams");
    handleDropdownClose();
    setTimeout(() => navigate("/login"), 50);
  };

  return (
    <section className="header navbar navbar-default navbar-fixed-top">
      <div className="container-fluid">
        <div className="navbar-header">
          <Link to="/" className="navbar-brand">
            <img
              src={process.env.PUBLIC_URL + "/logo1.png"}
              alt="Streetgains Logo"
              style={{
                height: "auto",
                width: "auto",
                marginRight: "8px",
                display: "inline-block",
                verticalAlign: "middle",
                objectFit: "contain",
                maxHeight: "40px",
              }}
            />
          </Link>

          {/* ✅ Toggle button that changes to cross when sidebar is open */}
          <button
            type="button"
            className="navbar-toggle"
            data-click="sidebar-toggled"
          >
            {isSidebarOpen ? (
              <span
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  lineHeight: "20px",
                  display: "inline-block",
                  marginTop: "-2px",
                  color: "black",
                }}
              >
                ×
              </span>
            ) : (
              <>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </>
            )}
          </button>
        </div>

        <div className="navbar-xs-justified">
          <ul className="nav navbar-nav navbar-right">
            <li className={`dropdown ${dropdownOpen ? "open" : ""}`}>
              <a href="#" onClick={toggleDropdown} className="dropdown-toggle">
                <span className="navbar-user-img online pull-left">
                 <img 
                    src={userData?.user_image || DefaultImage} 
                    alt="Profile" 
                    onError={(e) => {
                      e.target.src = DefaultImage;
                    }}
                  />
                </span>
                <span className="hidden-xs">
                  {userData ? userData.user_fullname : "Loading..."}
                  <FontAwesomeIcon
                    icon={faCaretDown}
                    className="pull-right"
                    style={{ marginLeft: "8px" }}
                  />
                </span>
              </a>

              {dropdownOpen && (
                <ul className="dropdown-menu" style={{ display: "block" }}>
                  <li>
                    <Link to="/profile" onClick={handleDropdownClose}>
                      View Profile
                    </Link>
                  </li>
                  <li className="divider"></li>
                  <li>
                    <button
                      onClick={handleLogout}
                      className="dropdown-item btn btn-light w-100 text-start"
                    >
                      Log Out
                    </button>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Header;
